module.exports = __webpack_public_path__ + "img/pic13.ffbf817c.png";